import { BRAND_PALETTES, PALETTE_SHADES } from "./constants/brandPalettes";

// Applies the shop brand to the storefront at runtime — the SPA counterpart of the FTL
// side's brand.ftl + .brand-<palette> theme scopes. The SCSS references the variables set
// here with the original flone values as fallback ($theme-color: var(--brand-500, #a749ff),
// $poppins: var(--brand-font, ...)), so a shop without a brand keeps the stock flone look.

// 400/700 are available for every font offered by the brand dialog's fontOptions; the
// css2 API rejects the whole request when an unavailable weight is asked for, so keep
// this list conservative.
const FONT_WEIGHTS = "400;700";
const FONT_LINK_ATTR = "data-brand-font";

const setRootVar = (name, value) => {
    if (value) document.documentElement.style.setProperty(name, value);
    else document.documentElement.style.removeProperty(name);
};

const fontHref = (family) =>
    `https://fonts.googleapis.com/css2?family=${encodeURIComponent(family).replace(/%20/g, "+")}:wght@${FONT_WEIGHTS}&display=swap`;

// Loads the given Google Font families and drops previously injected ones that are no
// longer wanted (site switch). Families the brand doesn't set simply aren't loaded.
const syncFontLinks = (families) => {
    const wanted = new Map(families.filter(Boolean).map((f) => [fontHref(f), f]));

    document.querySelectorAll(`link[${FONT_LINK_ATTR}]`).forEach((link) => {
        if (wanted.has(link.getAttribute("href"))) wanted.delete(link.getAttribute("href"));
        else link.remove();
    });

    wanted.forEach((family, href) => {
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = href;
        link.setAttribute(FONT_LINK_ATTR, family);
        document.head.appendChild(link);
    });
};

export const applyBrandTheme = (brand = {}) => {
    if (typeof document === "undefined") return;

    const palette = BRAND_PALETTES[brand.colorPalette] || {};
    PALETTE_SHADES.forEach((shade) => setRootVar(`--brand-${shade}`, palette[shade]));

    syncFontLinks([brand.font, brand.secondaryFont]);
    setRootVar("--brand-font", brand.font ? `"${brand.font}", sans-serif` : null);
    setRootVar("--brand-secondary-font", brand.secondaryFont ? `"${brand.secondaryFont}", sans-serif` : null);
};